// extracted by mini-css-extract-plugin
export default {"disabled":"FormType_disabled__YEgj3","transferSchema":"FormType_transferSchema__V95Lu","icon":"FormType_icon__Tw5Ti","badge":"FormType_badge__xcd3q","info":"FormType_info__qCYp6"};